import {Injectable} from '@angular/core';
import {InvitationOfferOverviewResponse} from '@frontend/shared-api';

@Injectable({
  providedIn: 'root',
})
export class TotalCostCalculationService {
  calculateServiceFeesTotal(overview: InvitationOfferOverviewResponse): number | undefined {
    if (!overview.serviceFeesResponse?.length || !overview.yearsInScope) {
      return undefined;
    }

    return overview.serviceFeesResponse.reduce((sum, fee) => {
      const feePerUnit = Number(fee.feePerUnit);
      const eligibleHeadcount = Number(fee.eligibleHeadcount);
      if (Number.isNaN(feePerUnit) || Number.isNaN(eligibleHeadcount)) {
        return sum;
      }
      return sum + feePerUnit * eligibleHeadcount * overview.yearsInScope;
    }, 0);
  }

  calculateImplementationFeesTotal(overview: InvitationOfferOverviewResponse): number | undefined {
    if (!overview.implementationActivityFeesResponse?.length) {
      return undefined;
    }

    return overview.implementationActivityFeesResponse.reduce((sum, activity) => {
      const hourlyRate = Number(activity.hourlyRate);
      if (Number.isNaN(hourlyRate)) {
        return sum;
      }

      const yearlyHours = (activity.implementationFunctionFeesResponse ?? []).reduce(
        (hoursSum, func) =>
          hoursSum +
          (func.implementationYearlyFees ?? []).reduce(
            (ySum, year) => ySum + (Number(year.feePerUnit) || 0),
            0,
          ),
        0,
      );

      return sum + yearlyHours * hourlyRate;
    }, 0);
  }

  calculateIntegrationSetupFeesTotal(
    overview: InvitationOfferOverviewResponse,
  ): number | undefined {
    if (!overview.integrationSetupFeesResponse?.length) {
      return undefined;
    }

    return overview.integrationSetupFeesResponse.reduce(
      (sum, fee) =>
        sum +
        (fee.yearlyItemFees ?? []).reduce((ySum, year) => ySum + (Number(year.feePerUnit) || 0), 0),
      0,
    );
  }

  calculateIntegrationOtherFeesTotal(
    overview: InvitationOfferOverviewResponse,
  ): number | undefined {
    if (!overview.integrationOtherFeesResponse?.length) {
      return undefined;
    }

    return overview.integrationOtherFeesResponse.reduce(
      (sum, fee) =>
        sum +
        (fee.yearlyItemFees ?? []).reduce((ySum, year) => ySum + (Number(year.feePerUnit) || 0), 0),
      0,
    );
  }
}
